/// REDUX ///
import { Dispatch } from "redux";
/// ACTIONS ///
import { Action } from "api/action_types/shop_quote";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_quote";
/// TYPES ///
import { IShopSink } from "api/types/shop_quote/sink";

export const deleteLocalShopSink = (sink: IShopSink) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.DELETE_LOCAL_SHOP_SINK,
      payload: sink
    });
  }
}
